var _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderConstructionIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 768",
    style: {
      enableBackground: "new 0 0 1024 768"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,476.8h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,476.8L595.5,476.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M597.2,492.4h-37.6V114.5h37.6V492.4z M563.4,488.5h29.9V118.4h-29.9V488.5z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 554.4,
    y: 472.2,
    style: {
      fill: "#9BC5E6"
    },
    width: 47.9,
    height: 34.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,334.8h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,334.8L595.5,334.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,370.3h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,370.3L595.5,370.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,405.8h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,405.8L595.5,405.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,441.3h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,441.3L595.5,441.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,300.2h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,300.2L595.5,300.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,265.5h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,265.5L595.5,265.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,230.8h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,230.8L595.5,230.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,196.2h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,196.2L595.5,196.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,161.5h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,161.5L595.5,161.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M595.5,126.9h-33.3c-0.8,0-1.5-0.5-1.8-1.2s-0.2-1.5,0.4-2.1l32-34.6l2.8,2.6l-29,31.4h28.9 L595.5,126.9L595.5,126.9z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 536.2,
    y: 76.2,
    style: {
      fill: "#9BC5E6"
    },
    width: 60.9,
    height: 51.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.7,
    y: 76.2,
    style: {
      fill: "#9BC5E6"
    },
    width: 60.9,
    height: 29.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M687.7,79.9h-301c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h301c1.1,0,1.9,0.9,1.9,1.9 C689.6,79.1,688.7,79.9,687.7,79.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.7,
    y: 90.8,
    style: {
      fill: "#9BC5E6"
    },
    width: 1.9,
    height: 75.6
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M580.1,76.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.1,
    y: 500.3,
    style: {
      fill: "#9BC5E6"
    },
    width: 80.5,
    height: 15.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M566.9,79.4c-0.2,0-0.5-0.1-0.7-0.3l-16-16H403l-15.1,15.1c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4 l15.7-15.7h148.7l16.6,16.6c0.4,0.4,0.4,1,0,1.4C567.4,79.3,567.1,79.4,566.9,79.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M689,79.4c-0.3,0-0.7-0.2-0.9-0.5L672,48.2h-39l-15,29.7c-0.2,0.5-0.8,0.7-1.3,0.4 c-0.5-0.2-0.7-0.8-0.4-1.3l15.6-30.8h41.3L689.8,78c0.2,0.5,0.1,1.1-0.4,1.3C689.3,79.4,689.1,79.4,689,79.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M408.7,87c0,3.9-3.2,7-7,7c-3.9,0-7-3.2-7-7s3.2-7,7-7C405.5,79.9,408.7,83.1,408.7,87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M443.3,63.1c-0.4,0-0.8-0.3-0.9-0.7c-0.2-0.5,0.1-1,0.6-1.2l142.2-43.4c0.2-0.1,0.4-0.1,0.7,0 l67.4,28.5c0.5,0.2,0.7,0.8,0.5,1.3s-0.8,0.7-1.3,0.5l-67.1-28.3L443.6,63C443.5,63.1,443.4,63.1,443.3,63.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M563.1,79.6c-0.2,0-0.5,0-0.7-0.1c-1-0.4-1.5-1.5-1.1-2.5l22.4-59c0.3-0.8,1.1-1.3,2-1.2 c0.9,0.1,1.6,0.7,1.7,1.5L599,75.8c0.2,1-0.5,2.1-1.5,2.3c-1,0.2-2.1-0.5-2.3-1.5l-10.3-51l-20,52.7 C564.6,79.1,563.9,79.6,563.1,79.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M589.4,18.7c0,2.1-1.7,3.9-3.9,3.9c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9 C587.7,14.8,589.4,16.6,589.4,18.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M423,79.6c-0.2,0-0.4-0.1-0.6-0.2l-18.9-15.2v14.3c0,0.5-0.4,1-1,1s-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C423.6,79.5,423.3,79.6,423,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M441.3,79.6c-0.2,0-0.4-0.1-0.6-0.2l-18.9-15.2v14.3c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C441.8,79.5,441.5,79.6,441.3,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M459.5,79.6c-0.2,0-0.4-0.1-0.6-0.2L440,64.2v14.3c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C460.1,79.5,459.8,79.6,459.5,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M477.7,79.6c-0.2,0-0.4-0.1-0.6-0.2l-18.9-15.2v14.3c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C478.3,79.5,478,79.6,477.7,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M496,79.6c-0.2,0-0.4-0.1-0.6-0.2l-18.9-15.2v14.3c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C496.6,79.5,496.3,79.6,496,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M514.2,79.6c-0.2,0-0.4-0.1-0.6-0.2l-18.9-15.2v14.3c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C514.8,79.5,514.5,79.6,514.2,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M532.5,79.6c-0.2,0-0.4-0.1-0.6-0.2L513,64.2v14.3c0,0.5-0.4,1-1,1s-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C533,79.5,532.8,79.6,532.5,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M550.7,79.6c-0.2,0-0.4-0.1-0.6-0.2l-18.9-15.2v14.3c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1V62.1 c0-0.4,0.2-0.7,0.5-0.9s0.7-0.1,1,0.1l20.4,16.5c0.4,0.3,0.5,0.9,0.1,1.4C551.3,79.5,551,79.6,550.7,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M658.6,79.6c-0.3,0-0.5-0.1-0.7-0.3l-24.5-28.9v28.1c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1V47.7 c0-0.4,0.3-0.8,0.6-0.9c0.4-0.1,0.8,0,1.1,0.3L659.3,78c0.3,0.4,0.3,1-0.1,1.4C659,79.5,658.8,79.6,658.6,79.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M677.4,79.6c-0.3,0-0.6-0.2-0.8-0.4L658,50.9v27.5c0,0.5-0.4,1-1,1s-1-0.4-1-1V47.7 c0-0.4,0.3-0.8,0.7-0.9c0.4-0.1,0.8,0,1.1,0.4l20.4,30.9c0.3,0.4,0.2,1-0.3,1.3C677.8,79.6,677.6,79.6,677.4,79.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC5E6"
    },
    d: "M407.7,169c0,3.3-2.7,6-6,6s-6-2.7-6-6s2.7-6,6-6C405,162.9,407.7,165.6,407.7,169z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 653.3,
    y1: 516.9,
    x2: 507.2,
    y2: 516.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#306F1D"
    },
    d: "M185.2,587.1l14.5,1.7l6.2-12.5l-10.2-10.5l0.7-11l11.4-9l-4.5-13.2l-14.6-0.2l-7.2-8.3 l1.7-14.5l-12.5-6.2l-10.5,10.2l-11-0.7l-9-11.4L127,506l-0.2,14.6l-8.3,7.2l-14.5-1.7l-6,12.5l10.2,10.5l-0.7,11L96,569 l4.5,13.2l14.6,0.2l7.2,8.3l-1.7,14.5l12.5,6.2l10.5-10.2l11,0.7l9,11.4l13.2-4.5l0.2-14.6L185.2,587.1z M163.1,570.1 c-7,6.2-17.7,5.5-23.9-1.6c-6.2-7-5.5-17.7,1.6-23.9c7-6.2,17.7-5.5,23.9,1.6C170.8,553.3,170.1,564,163.1,570.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M868.4,206.2l12.6,1.5l5.4-10.9l-8.8-9.1l0.6-9.5l10-7.9l-3.9-11.5l-12.7-0.2l-6.3-7.2l1.5-12.6 l-10.9-5.4l-9.1,8.8l-9.5-0.6l-7.9-10l-11.5,3.9l-0.2,12.7l-7.2,6.3l-12.6-1.5l-5.4,10.9l8.8,9.1l-0.6,9.5l-10,7.9l3.9,11.5 l12.7,0.2l6.3,7.2l-1.5,12.6l10.9,5.4l9.1-8.8l9.5,0.6l7.9,10l11.5-3.9l0.2-12.7L868.4,206.2z M848.4,190.6 c-5.7,5-14.3,4.4-19.3-1.3s-4.4-14.3,1.3-19.3s14.3-4.4,19.3,1.3S854.1,185.6,848.4,190.6z"
  })))))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.34,
      fill: "#8DDB43",
      enableBackground: "new"
    },
    points: "165.6,379.4 165.6,368.1 157.8,368.1 157.8,379.4  146.6,379.4 146.6,387.2 157.8,387.2 157.8,398.5 165.6,398.5 165.6,387.2 176.9,387.2 176.9,379.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.34,
      fill: "#8DDB43",
      enableBackground: "new"
    },
    points: "897.2,415.6 897.2,404.3 889.4,404.3 889.4,415.6  878.1,415.6 878.1,423.4 889.4,423.4 889.4,434.7 897.2,434.7 897.2,423.4 908.5,423.4 908.5,415.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.34,
      fill: "#8DDB43",
      enableBackground: "new"
    },
    points: "524.7,732.8 524.7,721.5 516.9,721.5 516.9,732.8  505.6,732.8 505.6,740.5 516.9,740.5 516.9,751.8 524.7,751.8 524.7,740.5 536,740.5 536,732.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9BC5E6"
    },
    points: "808.3,41.8 808.3,30.5 800.5,30.5 800.5,41.8 789.2,41.8 789.2,49.6 800.5,49.6 800.5,60.9  808.3,60.9 808.3,49.6 819.6,49.6 819.6,41.8 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBD5DF"
    },
    d: "M889,683.3H161.9c-6.6,0-10.8-7.2-7.5-12.9L246.8,510h557.3l92.4,160.4 C899.8,676.2,895.7,683.3,889,683.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.1,
    y1: 571.2436,
    x2: 526.1,
    y2: 322.0351,
    gradientTransform: "matrix(1 0 0 -1 0 768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035014,
    style: {
      stopColor: "#45436F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B2B4A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M823.1,520.6h-594V195.3c0-3.1,2.5-5.6,5.6-5.6h582.9c3.1,0,5.5,2.5,5.5,5.6V520.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111894187398215456130000016493401152569304989_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.1,
    y1: 547.6125,
    x2: 526.1,
    y2: 333.8557,
    gradientTransform: "matrix(1 0 0 -1 0 768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035014,
    style: {
      stopColor: "#9BC5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#558BB3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111894187398215456130000016493401152569304989_)"
    },
    points: "246.3,503.4 246.3,207  805.9,207 805.9,503.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M890.5,639.9L890.5,639.9c0-2-0.5-4.2-1.7-6.2l-66.4-113.1H228.7l-66.4,113.1 c-1.2,2-1.7,4.2-1.6,6.3l-0.1-0.1l0.1,14.9c-0.6,6.6,4.5,13,11.9,13h706c7.1,0,12.1-5.9,11.9-12.2V639.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0EBF6"
    },
    d: "M878.5,651.7h-706c-9.2,0-14.9-10-10.3-17.9l66.4-113.1h593.7l66.4,113.1 C893.5,641.7,887.8,651.7,878.5,651.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7BEC9"
    },
    d: "M842.3,597.4H215.2c-5.7,0-7.1-5.1-3.3-11.2l24.8-40.2c3.1-5.1,9.7-9.1,14.7-9.1H806 c5,0,11.6,4,14.7,9.1l24.8,40.2C849.4,592.3,847.9,597.4,842.3,597.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7BEC9"
    },
    d: "M597.1,637.3H438.4c-5,0-8-4.9-6.6-10.7l1.8-8c1.3-5.5,6.1-9.8,10.7-9.8h147.8 c4.7,0,9.3,4.3,10.4,9.8l1.5,8C605.2,632.4,602.1,637.3,597.1,637.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M748,568.9h32.5c1.7,0,2.8-0.4,2.6-0.9l-2.6-5.6c-0.2-0.5-1.7-0.9-3.4-0.9h-32 c-1.6,0-2.8,0.4-2.6,0.9l2.2,5.6C744.8,568.4,746.3,568.9,748,568.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M318.8,561.4h-32c-1.6,0-3.1,0.4-3.4,0.9l-2.5,5.6c-0.2,0.5,0.9,0.9,2.6,0.9H316 c1.7,0,3.2-0.4,3.4-0.9l2.1-5.6C321.6,561.8,320.4,561.4,318.8,561.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M375.2,562.3l-1.6,5.6c-0.1,0.5,1.1,0.9,2.7,0.9h32.5c1.7,0,3.1-0.4,3.2-0.9l1.2-5.6 c0.1-0.5-1.1-0.9-2.8-0.9h-32C376.7,561.4,375.3,561.8,375.2,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M650.6,562.3l1.3,5.6c0.1,0.5,1.6,0.9,3.2,0.9h32.5c1.7,0,2.9-0.4,2.7-0.9l-1.7-5.6 c-0.2-0.5-1.6-0.9-3.2-0.9h-32C651.7,561.4,650.5,561.8,650.6,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M421.1,562.3l-1.1,5.6c-0.1,0.5,1.2,0.9,2.8,0.9h32.5c1.7,0,3-0.4,3.1-0.9l0.7-5.6 c0.1-0.5-1.2-0.9-2.8-0.9h-32C422.6,561.4,421.2,561.8,421.1,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M467,562.3l-0.6,5.6c-0.1,0.5,1.2,0.9,2.9,0.9h32.5c1.7,0,3-0.4,3-0.9l0.2-5.6 c0-0.5-1.3-0.9-2.9-0.9h-32C468.4,561.4,467,561.8,467,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M512.9,562.3l-0.1,5.6c0,0.5,1.3,0.9,3,0.9h32.5c1.7,0,3-0.4,3-0.9l-0.2-5.6 c0-0.5-1.4-0.9-3-0.9h-32C514.2,561.4,512.9,561.8,512.9,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M604.7,562.3l0.8,5.6c0.1,0.5,1.5,0.9,3.1,0.9h32.5c1.7,0,2.9-0.4,2.8-0.9l-1.2-5.6 c-0.1-0.5-1.5-0.9-3.2-0.9h-32C605.9,561.4,604.6,561.8,604.7,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M558.8,562.3l0.3,5.6c0,0.5,1.4,0.9,3.1,0.9h32.5c1.7,0,2.9-0.4,2.9-0.9l-0.7-5.6 c-0.1-0.5-1.4-0.9-3.1-0.9h-32C560,561.4,558.7,561.8,558.8,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M364.6,561.4h-32c-1.6,0-3.1,0.4-3.3,0.9l-2.1,5.6c-0.2,0.5,1,0.9,2.7,0.9h32.5 c1.7,0,3.1-0.4,3.3-0.9l1.7-5.6C367.4,561.8,366.2,561.4,364.6,561.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M245.3,562.3l-2.9,5.6c-0.3,0.5,0.9,0.9,2.5,0.9h24.6c1.7,0,3.2-0.4,3.4-0.9l2.6-5.6 c0.2-0.5-0.9-0.9-2.5-0.9h-24.2C247.1,561.4,245.5,561.8,245.3,562.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M701.5,568.9H734c1.7,0,2.8-0.4,2.6-0.9l-2.2-5.6c-0.2-0.5-1.7-0.9-3.3-0.9h-32 c-1.6,0-2.8,0.4-2.7,0.9l1.8,5.6C698.4,568.4,699.9,568.9,701.5,568.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M702.8,582.4l2.2,7.1c0.2,0.6,1.7,1,3.4,1h33.8c1.7,0,2.9-0.5,2.7-1l-2.7-7.1 c-0.2-0.5-1.7-1-3.4-1h-33.2C703.8,581.4,702.6,581.8,702.8,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M274.3,582.4l-3.2,7.1c-0.3,0.6,0.9,1,2.7,1h33.8c1.7,0,3.3-0.5,3.5-1l2.7-7.1 c0.2-0.5-1-1-2.7-1h-33.2C276.1,581.4,274.6,581.8,274.3,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M234.8,582.4l-3.1,5.9c-0.7,1.3,2,2.3,5.9,2.3h21.6c1.7,0,3.3-0.5,3.6-1l3.3-7.1 c0.3-0.5-0.9-1-2.6-1h-25.1C236.7,581.4,235.1,581.8,234.8,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M750.4,582.4l2.8,7.1c0.2,0.6,1.8,1,3.5,1h33.8c1.7,0,2.9-0.5,2.6-1l-3.3-7.1 c-0.3-0.5-1.8-1-3.5-1h-33.2C751.4,581.4,750.2,581.8,750.4,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M828,590.5c3.9,0,6.5-1,5.9-2.3l-3.2-5.9c-0.3-0.5-1.9-1-3.6-1h-26.5c-1.7,0-2.9,0.4-2.6,1 l3.4,7.1c0.3,0.6,1.9,1,3.6,1h23V590.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M321.9,582.4l-2.6,7.1c-0.2,0.6,1,1,2.7,1h33.8c1.7,0,3.2-0.5,3.4-1l2.1-7.1 c0.2-0.5-1.1-1-2.8-1h-33.2C323.6,581.4,322.1,581.8,321.9,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M655.2,582.4l1.6,7.1c0.1,0.6,1.6,1,3.3,1h33.8c1.7,0,3-0.5,2.8-1l-2.1-7.1 c-0.2-0.5-1.7-1-3.4-1H658C656.3,581.4,655,581.8,655.2,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M643.7,581.4h-25.8h-10.5h-9.7h-36.3h-11.2h-36.3h-11.2h-36.3h-46c-1.7,0-3.2,0.4-3.3,1 l-1.4,7.1c-0.1,0.6,1.2,1,2.9,1h46.7h36.9h11.4h36.9H562h36.9h9.9h10.6h26.2c1.7,0,3-0.5,2.9-1l-1.5-7.1 C646.9,581.8,645.4,581.4,643.7,581.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M369.5,582.4l-2,7.1c-0.2,0.6,1.1,1,2.8,1h33.8c1.7,0,3.2-0.5,3.3-1l1.5-7.1 c0.1-0.5-1.2-1-2.9-1h-33.2C371.2,581.4,369.7,581.8,369.5,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M315,571.2h-32.6c-1.7,0-3.2,0.4-3.4,0.9l-2.6,5.9c-0.2,0.5,0.9,1,2.6,1h33c1.7,0,3.2-0.4,3.4-1 l2.2-5.9C317.8,571.6,316.6,571.2,315,571.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M325.7,572.1l-2.1,5.9c-0.2,0.5,1,1,2.7,1h33.1c1.7,0,3.2-0.4,3.3-1l1.7-5.9 c0.2-0.5-1.1-0.9-2.7-0.9H329C327.4,571.2,325.9,571.6,325.7,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M240.1,572.1l-3,5.9c-0.3,0.5,0.9,1,2.5,1h25c1.7,0,3.3-0.4,3.5-1l2.7-5.9 c0.2-0.5-0.9-0.9-2.6-0.9h-24.7C242,571.2,240.4,571.6,240.1,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M465.9,572.1l-0.7,5.9c-0.1,0.5,1.3,1,2.9,1h33.1c1.7,0,3.1-0.4,3.1-1l0.2-5.9 c0-0.5-1.3-0.9-3-0.9H469C467.3,571.2,465.9,571.6,465.9,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M559.4,572.1l0.3,5.9c0,0.5,1.4,1,3.1,1h33.1c1.7,0,3-0.4,2.9-1l-0.8-5.9 c-0.1-0.5-1.5-0.9-3.1-0.9h-32.6C560.6,571.2,559.3,571.6,559.4,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M372.4,572.1l-1.6,5.9c-0.1,0.5,1.1,1,2.8,1h33.1c1.7,0,3.1-0.4,3.3-1l1.2-5.9 c0.1-0.5-1.1-0.9-2.8-0.9h-32.6C374,571.2,372.5,571.6,372.4,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M752.1,579h33.1c1.7,0,2.8-0.4,2.6-1l-2.7-5.9c-0.2-0.5-1.8-0.9-3.5-0.9H749 c-1.7,0-2.8,0.4-2.6,0.9l2.3,5.9C748.8,578.5,750.4,579,752.1,579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M419.1,572.1L418,578c-0.1,0.5,1.2,1,2.9,1H454c1.7,0,3.1-0.4,3.2-1l0.7-5.9 c0.1-0.5-1.2-0.9-2.9-0.9h-32.6C420.7,571.2,419.2,571.6,419.1,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M512.6,572.1l-0.2,5.9c0,0.5,1.3,1,3,1h33.1c1.7,0,3-0.4,3-1l-0.3-5.9c0-0.5-1.4-0.9-3.1-0.9 h-32.6C514,571.2,512.6,571.6,512.6,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M606.1,572.1l0.8,5.9c0.1,0.5,1.5,1,3.2,1h33.1c1.7,0,3-0.4,2.8-1l-1.2-5.9 c-0.1-0.5-1.5-0.9-3.2-0.9H609C607.3,571.2,606,571.6,606.1,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M652.8,572.1l1.3,5.9c0.1,0.5,1.6,1,3.3,1h33.1c1.7,0,2.9-0.4,2.8-1l-1.7-5.9 c-0.2-0.5-1.6-0.9-3.3-0.9h-32.6C654,571.2,652.7,571.6,652.8,572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M811.3,551.9h-25.1c-1.6,0-2.7,0.4-2.5,0.9l1.7,3.6l1.1,2.3l4.5,9.3c0.2,0.5,1.8,0.9,3.4,0.9 h25.9c1.7,0,2.8-0.4,2.5-0.9l-5-9.3l-1.3-2.3l-1.9-3.6C814.4,552.3,812.9,551.9,811.3,551.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M641.8,558.2l-1.2-5.4c-0.1-0.5-1.5-0.9-3.1-0.9H606c-1.6,0-2.8,0.4-2.8,0.9l0.8,5.4 c0.1,0.5,1.4,0.9,3.1,0.9H639C640.7,559.1,641.9,558.7,641.8,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M687.4,558.2l-1.6-5.4c-0.1-0.5-1.6-0.9-3.2-0.9h-31.5c-1.6,0-2.8,0.4-2.7,0.9l1.2,5.4 c0.1,0.5,1.5,0.9,3.1,0.9h31.9C686.3,559.1,687.5,558.7,687.4,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M250.2,552.8l-2.8,5.4c-0.3,0.5,0.8,0.9,2.5,0.9H274c1.6,0,3.1-0.4,3.4-0.9l2.5-5.4 c0.2-0.5-0.9-0.9-2.5-0.9h-23.8C252,551.9,250.5,552.3,250.2,552.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M414,558.2l1.1-5.4c0.1-0.5-1.1-0.9-2.7-0.9H381c-1.6,0-3,0.4-3.2,0.9l-1.5,5.4 c-0.1,0.5,1.1,0.9,2.7,0.9h31.9C412.5,559.1,413.9,558.7,414,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M505.1,558.2l0.2-5.4c0-0.5-1.3-0.9-2.9-0.9H471c-1.6,0-2.9,0.4-3,0.9l-0.6,5.4 c-0.1,0.5,1.2,0.9,2.8,0.9h31.9C503.8,559.1,505.1,558.7,505.1,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M550.7,558.2l-0.2-5.4c0-0.5-1.3-0.9-2.9-0.9h-31.5c-1.6,0-2.9,0.4-2.9,0.9l-0.1,5.4 c0,0.5,1.3,0.9,2.9,0.9h31.9C549.4,559.1,550.7,558.7,550.7,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M459.6,558.2l0.7-5.4c0.1-0.5-1.2-0.9-2.8-0.9H426c-1.6,0-3,0.4-3.1,0.9l-1.1,5.4 c-0.1,0.5,1.1,0.9,2.8,0.9h31.9C458.2,559.1,459.5,558.7,459.6,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M596.3,558.2l-0.7-5.4c-0.1-0.5-1.4-0.9-3-0.9h-31.5c-1.6,0-2.9,0.4-2.9,0.9l0.3,5.4 c0,0.5,1.4,0.9,3,0.9h31.9C595.1,559.1,596.3,558.7,596.3,558.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M322.4,551.9H291c-1.6,0-3.1,0.4-3.3,0.9l-2.5,5.4c-0.2,0.5,0.9,0.9,2.5,0.9h31.9 c1.6,0,3.1-0.4,3.3-0.9l2.1-5.4C325.2,552.3,324,551.9,322.4,551.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M698.4,559.1h31.9c1.6,0,2.8-0.4,2.6-0.9l-2.1-5.4c-0.2-0.5-1.6-0.9-3.2-0.9h-31.5 c-1.6,0-2.8,0.4-2.6,0.9l1.7,5.4C695.4,558.7,696.8,559.1,698.4,559.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M744.1,559.1H776c1.6,0,2.8-0.4,2.5-0.9l-2.5-5.4c-0.2-0.5-1.7-0.9-3.3-0.9h-31.5 c-1.6,0-2.7,0.4-2.6,0.9l2.2,5.4C741,558.7,742.4,559.1,744.1,559.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M367.4,551.9H336c-1.6,0-3,0.4-3.2,0.9l-2,5.4c-0.2,0.5,1,0.9,2.6,0.9h31.9 c1.6,0,3.1-0.4,3.2-0.9l1.6-5.4C370.2,552.3,369,551.9,367.4,551.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M729.3,548.8l-2-5.3c-0.2-0.5-1.6-0.8-3.2-0.8h-30.9c-1.6,0-2.7,0.4-2.6,0.8l1.6,5.3 c0.1,0.5,1.6,0.9,3.2,0.9h31.3C728.4,549.7,729.5,549.3,729.3,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M550.3,548.8l-0.2-5.3c0-0.5-1.3-0.8-2.9-0.8h-30.9c-1.6,0-2.9,0.4-2.9,0.8l-0.1,5.3 c0,0.5,1.3,0.9,2.9,0.9h31.3C549,549.7,550.3,549.3,550.3,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M505.5,548.8l0.2-5.3c0-0.5-1.2-0.8-2.8-0.8H472c-1.6,0-2.9,0.4-2.9,0.8l-0.6,5.3 c-0.1,0.5,1.2,0.9,2.8,0.9h31.3C504.2,549.7,505.5,549.3,505.5,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M740.3,549.7h31.3c1.6,0,2.7-0.4,2.5-0.9l-2.5-5.3c-0.2-0.5-1.7-0.8-3.3-0.8h-30.9 c-1.6,0-2.7,0.4-2.5,0.8l2.1,5.3C737.2,549.3,738.7,549.7,740.3,549.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M684.6,548.8l-1.6-5.3c-0.1-0.5-1.5-0.8-3.1-0.8H649c-1.6,0-2.8,0.4-2.7,0.8l1.2,5.3 c0.1,0.5,1.5,0.9,3.1,0.9h31.3C683.5,549.7,684.7,549.3,684.6,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M255,543.6l-2.7,5.3c-0.2,0.5,0.8,0.9,2.4,0.9h23.7c1.6,0,3.1-0.4,3.3-0.9l2.4-5.3 c0.2-0.5-0.9-0.8-2.5-0.8h-23.4C256.7,542.7,255.3,543.1,255,543.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M326,542.7h-31c-1.6,0-3,0.4-3.2,0.8l-2.4,5.3c-0.2,0.5,0.9,0.9,2.5,0.9h31.3 c1.6,0,3-0.4,3.2-0.9l2-5.3C328.7,543.1,327.5,542.7,326,542.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M371.2,548.8l1.6-5.3c0.1-0.5-1-0.8-2.6-0.8h-30.9c-1.6,0-3,0.4-3.2,0.8l-1.9,5.3 c-0.2,0.5,1,0.9,2.6,0.9h31.3C369.7,549.7,371.1,549.3,371.2,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M595.1,548.8l-0.7-5.3c-0.1-0.5-1.4-0.8-3-0.8h-30.9c-1.6,0-2.8,0.4-2.8,0.8l0.3,5.3 c0,0.5,1.3,0.9,2.9,0.9h31.3C593.9,549.7,595.1,549.3,595.1,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M812.5,548.8l-2.8-5.3c-0.3-0.5-1.7-0.8-3.3-0.8h-24.7c-1.6,0-2.7,0.4-2.4,0.8l2.5,5.3 c0.2,0.5,1.7,0.9,3.3,0.9h25C811.7,549.7,812.8,549.3,812.5,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M639.8,548.8l-1.1-5.3c-0.1-0.5-1.5-0.8-3-0.8h-30.9c-1.6,0-2.8,0.4-2.7,0.8l0.8,5.3 c0.1,0.5,1.4,0.9,3,0.9h31.3C638.7,549.7,639.9,549.3,639.8,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M460.8,548.8l0.7-5.3c0.1-0.5-1.2-0.8-2.7-0.8h-30.9c-1.6,0-2.9,0.4-3,0.8l-1,5.3 c-0.1,0.5,1.1,0.9,2.7,0.9h31.3C459.4,549.7,460.7,549.3,460.8,548.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M416,548.8l1.1-5.3c0.1-0.5-1.1-0.8-2.7-0.8h-30.9c-1.6,0-3,0.4-3.1,0.8l-1.5,5.3 c-0.1,0.5,1.1,0.9,2.6,0.9h31.3C414.5,549.7,415.9,549.3,416,548.8z"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D6100"
    },
    points: "215.7,405.5 229.2,405.5 229.2,419.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D6100"
    },
    points: "836.5,405.5 823.1,405.5 823.1,419.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.1,
    y: 232.2,
    style: {
      opacity: 0.55,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 146.1,
    height: 250.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.3,
    y: 246.5,
    style: {
      opacity: 0.55,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 121,
    height: 32.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.3,
    y: 290.2,
    style: {
      opacity: 0.55,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 121,
    height: 176.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 443.2,
    y: 232.5,
    style: {
      opacity: 0.55,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 340.9,
    height: 250.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 459.6,
    y: 246.5,
    style: {
      opacity: 0.55,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 309.7,
    height: 32.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.6,
    y: 290.2,
    style: {
      opacity: 0.55,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 309.7,
    height: 176.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M335,445.4h-7.5c-2.8,0-5.3,2-6.4,5L261.6,614h139.5l-59.6-163.6 C340.4,447.4,337.8,445.4,335,445.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003104503501035121810000006686828257177398967_",
    d: "M335,445.4h-7.5c-2.8,0-5.3,2-6.4,5L261.6,614h139.5 l-59.6-163.6C340.4,447.4,337.8,445.4,335,445.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027584529002842252280000002075186670885607827_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003104503501035121810000006686828257177398967_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 486.3,
    style: {
      clipPath: "url(#SVGID_00000027584529002842252280000002075186670885607827_)",
      fill: "#FFFFFF"
    },
    width: 127.5,
    height: 33.8
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000069367953058062550850000014342285818432987808_",
    d: "M335,445.4h-7.5c-2.8,0-5.3,2-6.4,5L261.6,614h139.5 l-59.6-163.6C340.4,447.4,337.8,445.4,335,445.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114055585901838174680000005640209619312927881_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069367953058062550850000014342285818432987808_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 552.4,
    style: {
      clipPath: "url(#SVGID_00000114055585901838174680000005640209619312927881_)",
      fill: "#FFFFFF"
    },
    width: 127.5,
    height: 33.8
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "#191919"
    },
    d: "M342.7,553.4c-1.9,9.9-4.8,19.4-8.2,28.9c-3.2,8.6-6.8,17.3-12.7,24.4 c-2.3,2.8-4.9,5.2-7.6,7.4h86.9l-59.6-163.6c-1.1-3-3.6-5-6.4-5h-0.9C345.2,480.2,349.6,517.3,342.7,553.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#306F1D"
    },
    d: "M414,627.9H248.6c-1.6,0-2.8-1.3-2.8-2.8V615c0-1.6,1.3-2.8,2.8-2.8H414c1.6,0,2.8,1.3,2.8,2.8 v10.1C416.8,626.6,415.6,627.9,414,627.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079485670176888927710000015577569154094872246_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.094,
    y1: 615.2,
    x2: 603.0564,
    y2: 372.8143,
    gradientTransform: "matrix(1 0 0 -1 0 768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0378151,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000079485670176888927710000015577569154094872246_)"
    },
    points: "675.9,206.4 472.9,502.9  571.7,502.9 774.7,206.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062171980587937336960000009849365631238672293_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.0484,
    y1: 603.8744,
    x2: 498.9659,
    y2: 375.0803,
    gradientTransform: "matrix(1 0 0 -1 0 768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0378151,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062171980587937336960000009849365631238672293_)"
    },
    points: "595.3,206.4 392.3,502.9  441.7,502.9 644.8,206.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 215.7,
    y: 325.3,
    style: {
      fill: "#5DAC32"
    },
    width: 620.5,
    height: 80.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "277.6,325.3 215.7,387.2 215.7,405.5 242.9,405.5 323.1,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "374.2,325.3 294,405.5 339.4,405.5 419.6,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "663.9,325.3 583.7,405.5 629.1,405.5 709.4,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "760.5,325.3 680.3,405.5 725.7,405.5 805.9,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "567.4,325.3 487.2,405.5 532.6,405.5 612.8,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "836.3,346.1 776.9,405.5 822.3,405.5 836.3,391.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "470.8,325.3 390.6,405.5 436,405.5 516.2,325.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "277.6,325.3 215.7,325.3 215.7,387.2  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "323.1,325.3 242.9,405.5 294,405.5 374.2,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "419.6,325.3 339.4,405.5 390.6,405.5 470.8,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "516.2,325.3 436,405.5 487.2,405.5 567.4,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "612.8,325.3 532.6,405.5 583.7,405.5 663.9,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "709.4,325.3 629.1,405.5 680.3,405.5 760.5,325.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "836.3,325.3 805.9,325.3 725.7,405.5 776.9,405.5 836.3,346.1  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#CBD5DF"
    },
    cx: 859.1,
    cy: 743.7,
    rx: 50.7,
    ry: 9.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10101F"
    },
    d: "M842,724.3l0.2,4.4c0.1,2.5-1.8,4.7-4.3,4.9l-7.4,0.5c-3,0.2-5.4,2.8-5.3,5.8l0.1,3 c0,1.6,1.4,2.9,3,2.8l24-1.1c1.9-0.1,3.4-1.7,3.4-3.7l-0.6-17.8L842,724.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10101F"
    },
    d: "M897,737.7l-4.1-17.3l-12.5,3.8l1.1,4.3c0.6,2.4-0.8,4.9-3.2,5.6l-7.2,2c-2.9,0.8-4.7,3.8-4,6.8 l0.7,2.9c0.4,1.6,1.9,2.5,3.5,2.1l23.3-5.9C896.3,741.5,897.4,739.6,897,737.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M860.7,518.7c0,0-2.5-0.6-6.9,0.8c-3.8,1.2-7.2,3.3-10.1,6l-23.4,21.7c-2.3,2.2-2.8,5.7-1.1,8.4 l0,0c2,3.2,6.2,4.1,9.3,2.1l20.5-13.5L860.7,518.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M832.4,553.1l-2.2,2.9c-3.6,4.8-11,3.8-13.2-1.7l-12.9-32.4l9.2-3.1L832.4,553.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172427620950770228950000004185472389351738540_",
    gradientUnits: "userSpaceOnUse",
    x1: 835.2,
    y1: 111.65,
    x2: 871.9392,
    y2: 111.65,
    gradientTransform: "matrix(1 0 0 -1 0 768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08823529,
    style: {
      stopColor: "#282844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9734,
    style: {
      stopColor: "#353458"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000172427620950770228950000004185472389351738540_)"
    },
    points: "845.4,586 835.2,668.2  839.3,727.2 856.5,726.2 858.4,668.7 872,585.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M858.2,595.2l-2,20.5c-0.4,4.2-0.3,8.5,0.5,12.7l6.9,39.6l15.5,59.5l15.2-1.7l-7.7-60.2 l2.6-48.3c0.2-3.1-0.2-6.1-1-9.1l-1.6-15.8L858.2,595.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M886.8,602.3c-5.7,1.3-19.6,7.3-37-2.5c-2.2-1.3-4.2-2.2-5.8-4c1.1-12,2.3-23.1,2.5-31.1 c0.3-11,0.8-18.5,0.8-27.9c0-1.2,0-11.5,4.5-16.7c3.1-2.1,7.5-3.2,12.6-3.2l1.1-0.1c8.3,0,21.5,4.7,21.5,13l3.1,34.4 L886.8,602.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBD5DF"
    },
    d: "M887.2,529.5c0-6.2-7.7-9.9-15-11.8c21.1,26.6,14,63-8.7,86.7c10.9,1.9,19.3-1.4,23.4-2.4 l3.5-38.1L887.2,529.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB8B76"
    },
    d: "M863.2,527.4c-3.3,1.1-9.5,1.8-8.6-2.6c0.2-0.9,0.8-1.8,1.2-2.7c0.3-0.7,2.3-2.5,2.3-3.2 l-0.4-8.4l13-0.1v7c0,4-2.6,7.6-6.1,9.4C864.3,527.1,863.8,527.2,863.2,527.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M851.8,494.2l-0.2,16.3c0,1.6,1.1,3,2.7,3.3c3.9,0.7,11.3,1.4,17-2.2c5.9-3.8,5.4-14,4.6-19.5 c-0.3-2.3-1.7-4.3-3.8-5.4c-3.8-2-10.3-4.3-15.6-1.1C853.6,487.4,851.9,490.8,851.8,494.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M851.7,498.6l-2.5,5.8c-0.3,0.8,0.2,1.6,1.1,1.6h3.7L851.7,498.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A2946"
    },
    d: "M864.4,493.3c0,0-1.5,3.8,2.6,7.9l0.2,2.6h1.9c0,0,0.1-2.8,0.1-3.8c0-1.2,1.5-1.4,2.4-0.9 c1,0.7,0.9,2.3,0.8,3.4c-0.1,1.5-0.7,2.5-1.8,3.4c-0.7,0.5-1.1,3.2-1.5,4.5c-0.3,0.9-0.4,1.7-0.4,2.4c2.5,0.3,4-0.3,4.8-0.8 c3-1.6,7.5-15.3,1.6-19L864.4,493.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD300"
    },
    d: "M880.3,496.9c0.6-2.4,0.8-4.1,0.8-6.3c0-8.1-7.9-14.4-16-14.4s-14.6,6.6-14.6,14.6 c0,0.2,0.1,0.5,0.1,0.7C859.6,493.5,871.2,494.5,880.3,496.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD300"
    },
    d: "M880.2,497.9l-34.8-5.6c0.6-0.7,2-2.1,4.2-2.7c1.4-0.4,2.6-0.3,3.4-0.2 c9.7,1.8,19.4,3.7,27.7,5.3L880.2,497.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7D7"
    },
    d: "M924.9,639.1l-56,9.9c-0.4,0.1-0.9-0.2-1-0.7l-5.7-32.4c-0.1-0.4,0.2-0.9,0.7-1l56-9.9 c0.4-0.1,0.9,0.2,1,0.7l5.7,32.4C925.7,638.6,925.4,639.1,924.9,639.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M927.3,638.6l-56,9.9c-0.4,0.1-0.9-0.2-1-0.7l-5.7-32.4c-0.1-0.4,0.2-0.9,0.7-1l56-9.9 c0.4-0.1,0.9,0.2,1,0.7l5.7,32.4C928.1,638.1,927.8,638.5,927.3,638.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEBEBE"
    },
    d: "M896.2,615.8c3.6-1.9,6.5-4.9,8.5-8.3l-26.1,4.6C883.7,616.4,889.4,619.4,896.2,615.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M890.2,611c-3,2.9-6,6.7-5.6,10.9c0.1,0.9,0.4,1.8,1.1,2.3c0.8,0.6,2,0.6,3,0.5 c6-0.8,11.5-4.3,14.9-9.3c2.4-3.6,4.3-11.8-1.8-13.2C897.2,600.9,892.9,608.3,890.2,611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M873.4,531.3c0.2,0.9,0.5,1.9,0.9,2.9c1.3,3.5,3.4,6.7,6.1,9.4l22.1,22.6c2,2,5,2.8,7.6,1.7 c4-1.7,5.2-6.6,2.9-10l-24-30.6c-1.6-2-3.8-4-6.2-4.8c-3.2-1-6-0.1-6,0C873.5,523.6,872.6,528,873.4,531.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M902.4,559.5l3.5-1.1c5.7-1.8,11.1,3.4,9.7,9.1l-9.8,39.5l-9.2-2.9L902.4,559.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M884.7,609.6c-0.3,0.2-0.7,0.4-0.7,0.8c0,0.4,0.3,0.6,0.6,0.8c1.3,0.7,2.9,0.8,4.4,0.6 c1.5-0.3,2.9-0.9,4.2-1.5c1.2-0.6,2.4-1.3,3.2-2.3c0.5-0.7,1.5-2.6,0.6-3.4c-0.8-0.8-2.8,0.7-3.7,1.1 C890.5,606.9,887.6,608.3,884.7,609.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M815.8,508c0.1,1.5-0.7,4.1-1.4,5.9c-0.6,1.5-1.3,2.6-1.9,3.4c0.6,1.4,1.3,2.7,1.9,4.1l-8.9,2.5 c0,0-6.5-11.2-5.6-17.3c1-6,3.4-3.5,3.4-3.5L815.8,508z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M821.6,494.8l-13,21.9c-0.4,0.6-1.1,0.8-1.8,0.5l-6-3.6c-0.8-0.5-1.1-1.6-0.6-2.4l12.7-21.5 c0.5-0.9,1.6-1.2,2.5-0.6l5.6,3.3C821.8,492.9,822.1,494,821.6,494.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M801.6,458.6c2.2,5.8,5.9,13.7,12.1,21.8c5,6.5,10.1,11.3,14.4,14.8c1.1,0.9,1.5,2.4,1,3.8 c-0.4,1.2-1.2,2.6-2.4,3.8c-1,1-2,1.6-2.9,2.1c-1.1,0.5-2.4,0.4-3.4-0.3c-5.2-3.6-11.4-7.4-18.6-11 c-8.3-4.2-16.1-7.1-22.8-9.1C786.5,475.9,794.1,467.3,801.6,458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#306F1D"
    },
    d: "M793.3,473.9c-6.2,7.2-12.6,11.9-14.4,10.4c-1.8-1.5,1.8-8.6,7.9-15.9 c6.2-7.2,12.6-11.9,14.4-10.4C803,459.6,799.5,466.7,793.3,473.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M810.4,505.7c-2.3,4-5.2,5.1-7.5,3.7c-2.4-1.4-3.4-4.7-1.1-8.7c2.3-4,5.3-4.5,7.7-3.2 C812.6,499.4,812.7,501.7,810.4,505.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M816,503.7c0-0.4-0.2-0.8-0.5-1c-1.2-0.6-2.1,1.1-2.3,1.6c-0.7,1.7-1,2.8-1.1,4.7 c-0.2,2-0.1,5.4,1.1,4.1c1.3-1.3,2.2-3.1,2.5-4C816.1,507.3,816.1,505.4,816,503.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M790.6,476.7c2.1-2.2,4.4-4.1,5.7-6.9c-0.7-0.5-1.6-0.7-2.6-0.7c-2.6,0-4.7,2-4.7,4.4 C789.1,474.9,789.6,475.9,790.6,476.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF7966"
    },
    d: "M857.7,514.2l0.4,5.5c0,0,3.9,1.5,8.5-6.3C866.7,513.5,863.7,514.8,857.7,514.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075150140587972408720000005487823297781370253_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.35,
    y1: 577.42,
    x2: 264.35,
    y2: 564.8882,
    gradientTransform: "matrix(1 0 0 -1 0 768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08823529,
    style: {
      stopColor: "#282844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9734,
    style: {
      stopColor: "#353458",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 189.9,
    style: {
      fill: "url(#SVGID_00000075150140587972408720000005487823297781370253_)"
    },
    width: 36.7,
    height: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10101F"
    },
    d: "M206.2,228.1c-0.5,1.3-1.5,7.6-4.3,9c-2.3,1.1-7.5,2-10.2,1.9c-3.1,0-3.8,4.4-3.6,5.4 c0.6,2.8,11.8,2,14.3,1.8c3.8-0.3,7.5-0.6,11.3-0.8c0.6,0,1.3-0.1,1.9-0.3c0.6-0.2,1.1-0.7,1.2-1.4c0.1-0.7-0.2-1.3-0.5-2 c-0.8-1.7,0.8-11.2,0.7-13.1C217,228.1,206.6,227.1,206.2,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#306F1D"
    },
    d: "M226.9,155.4l-0.8,8.1l31.2,4.1c4.2,0.5,8.2-2.6,8.9-6.9c1.8-11.7,4.8-32.8,3.3-39.2 c-2.1-9-13.8-9.7-15.7,4l-0.9,30L226.9,155.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DB8B76"
    },
    points: "252,110.3 257.3,116.4 266.2,110 257,103.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004516731484481700110000008365995981600477078_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.5607,
    y1: 584.1335,
    x2: 214.5607,
    y2: 544.3568,
    gradientTransform: "matrix(1 0 0 -1 0 768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08823529,
    style: {
      stopColor: "#282844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9734,
    style: {
      stopColor: "#353458"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004516731484481700110000008365995981600477078_)"
    },
    d: "M207.2,176l-2.6,54.3l12.3,0.7 c0,0,10.2-35.7,7-51.5L207.2,176z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 205.3,
    y: 162.4,
    style: {
      fill: "#25233F"
    },
    width: 25.1,
    height: 4.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#25233F"
    },
    points: "188.7,147.6 208.1,163.5 205.3,166.9 183.2,148.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M258.7,98.4c-0.8-3.6-3.1-6.4-6.2-8.3c-3.1-1.9-6.5-2.9-9.9-1.5c-3.1,1.3-5.6,4.1-6.3,7.4 c-0.7,1-0.8,2.3-0.6,3.5c0.3,1.6,1.2,2.9,2,4.3c0.2,0.3,0.4,0.6,0.6,0.9c-0.2,1.1-0.2,2.7-0.3,3.9c0,1,1,1.3,1.8,0.7 c0.3-0.3,0.6-0.5,0.9-0.7c1.1,1.7,2.2,3.4,3.2,5.1c0.6,0.9,1.2,1.9,2.2,2.3c0.9,0.4,1.8-0.1,2.7-0.5c3.5-1.8,6.1-4.1,8.5-7.2 c1.4-1.7,2-3.2,2.2-5.4C259.7,101.2,259,99.9,258.7,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M242.3,97.4l5.8,7l3.2-2.3l4.4,2.4c1.9,1,4.2,0,4.7-2c0.9-3.7,1.3-9.3-2.6-14.1L242.3,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD300"
    },
    d: "M232.1,104.8l27.2-15.9c0.7-0.4,0.9-1.2,0.4-1.9c-2.1-3.1-8.2-10.6-19.1-5.8 c-2.9,1.3-8.1,6.4-6.6,16.1c0.1,0.8-0.1,1.6-0.6,2.2c-0.5,0.5-1,1.1-1.3,2C231.6,103.1,232,104.4,232.1,104.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M252.1,100.5c0,0.5-0.1,1-0.3,1.4c-0.2,0.3-0.7,0.9-1.1,0.9c-0.3-0.1-1.8-2-2-2.4 c-0.2-0.3-0.5-0.5-0.4-0.9c0.1-0.7,0.9-1,1.5-1C250.9,98.4,252,99.3,252.1,100.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10101F"
    },
    d: "M181.1,214.1c-1.2,0.7-6,5-9.1,4.2c-2.5-0.6-7-3.3-9.1-5c-2.4-2-5.8,0.9-6.3,1.9 c-1.4,2.5,7.8,9,9.8,10.5c3.1,2.2,6.2,4.4,9.2,6.5c0.5,0.4,1.1,0.7,1.7,0.9c0.6,0.2,1.3,0.1,1.8-0.3c0.5-0.4,0.7-1.2,0.9-1.8 c0.5-1.8,7.7-8.1,8.9-9.6C189.4,221,182,213.6,181.1,214.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44426E"
    },
    d: "M180.5,215.5l7.6,6c0,0,25.6-19,30.3-37.7l48.4,8.7c6.4,1.2,13-1.1,17.4-6l0,0c2.2-2.5,3.3-5.7,3-9 l-0.3-4.2l-22.6-5.1l-43.4-5.9c-5.1-0.7-10.1,1.7-12.7,6.2L180.5,215.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DAC32"
    },
    d: "M287.8,181.4c0.8-5.6,0.7-5.2,0.5-7.4l-3.6-38.6c-0.8-8.4-4.9-16-11.4-21.3l-4.4-3.7 c-2.5-2.1-5.2-2.9-8.4,0.7l-3.8,4.8c-0.4,10.1-3.3,50.4-3.3,50.4c17.3,9.4,24,24.2,24.5,25.2C282.1,189.6,286.9,187.4,287.8,181.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE9881"
    },
    d: "M237.5,158.9c-0.3-0.2-0.5-0.4-0.8-0.6c-4.2-0.3-8.3-1.5-12.5-2.3c-2.3-0.4-4.4-1.3-6.7-0.9 c-4,0.6-6.8,3.2-6.6,7.3l12.6,0.6c1.8,0,3.7,0.2,5.4,0.7l10.7,2.2L237.5,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#306F1D"
    },
    d: "M234.5,156.7l-0.2,8.5l31.8,7.4c4.2,1,8.1-2,8.5-6.5c1-12.2,2.6-34.5,0.6-41.5 c-2.8-9.8-14.6-11.7-15.6,2.7l1.1,31.8L234.5,156.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "#191919"
    },
    d: "M808.4,325.5v20.4c0,21.1-17.1,38.3-38.3,38.3H217v21.5h620v-80.1H808.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstructionIllustration);
export default __webpack_public_path__ + "static/media/under-construction_illustration.8da438b551d3700e0dfe79cb27897ae1.svg";
export { ForwardRef as ReactComponent };